export type AuthRetryDelay = (ms: number) => Promise<any>;

const delay: AuthRetryDelay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

// A custom token can be valid before every Cloud Run instance observes its
// authorization context. Retry one 403 after a short delay; all other errors
// remain immediate and a second 403 is returned to the caller.
export const retryOnAuthPropagation = async <T>(
  fn: () => Promise<T>,
  wait: AuthRetryDelay = delay,
): Promise<T> => {
  try {
    return await fn();
  } catch (error) {
    const err: any = error;
    const status = err && err.response ? err.response.status : null;
    if (status !== 403) throw error;
    await wait(1200);
    return fn();
  }
};
